<template>
	<div>
		<label class="col-form-label">
			{{ this.$t('bookings.pickupDatetime') }}
			<b-button
				v-if="requireFlightDatas && !unableEdit"
				:disabled="calculatePickupLoading"
				size="sm"
				variant="warning"
				@click="calculatePickup"
				>{{ this.$t('bookings.calculate') }} <b-spinner v-if="calculatePickupLoading" small
			/></b-button>
		</label>
		<b-form-row>
			<b-col cols="12" md="5">
				<DateField disabled v-model="pickupDatetime" />
			</b-col>
			<b-col cols="12" md="4">
				<md-icon icon="access_time" />
				<TimeField :disabled="unableEdit" v-model="pickupDatetime" />
			</b-col>
		</b-form-row>
		<b-form-row class="mb-1">
			<b-col cols="12" md="12">
				<span
					:class="
						timeBetwenFlightAndPickupAbs > 500 ? 'text-danger' : ''
					"
					v-if="timeBetwenFlightAndPickup"
				>
					<strong>{{ timeBetwenFlightAndPickupAbs }}</strong> {{ this.$t('bookings.minutes') }}
					<strong>{{
						timeBetwenFlightAndPickup >= 0 ? this.$t('bookings.before') : this.$t('bookings.after')
					}}</strong>
					{{ this.$t('global.ofFlight') }} <br />
					<span v-if="routeTime"
						>{{ this.$t('bookings.transferTime') }}
						<strong>{{ routeTime }} {{ this.$t('bookings.minutes') }}</strong></span
					>
					<span v-if="requirePrevFlightTime">
						| {{ this.$t('bookings.preFlightTime') }}
						<strong
							>{{ requirePrevFlightTime }} {{ this.$t('bookings.minutes') }}</strong
						></span
					>
				</span>
			</b-col>
		</b-form-row>
	</div>
</template>

<script>
//Helpers
import DateField from "../helpers/_dateField";
import TimeField from "../helpers/_timeField";
import { mapFields } from "../helpers/helpers";
import moment from "moment";
import api from "@/api.js";
export default {
	props: {
		requireFlightDatas: Boolean,
		unableEdit: Boolean,
		index: Number
	},
	components: {
		DateField,
		TimeField
	},
	data: () => ({
		requirePrevFlightTime: 0,
		calculatePickupLoading: false,
		routeTime: 0
	}),
	beforeCreate() {
		this.$options.computed = {
			...mapFields({
				fields: [
					"pickupDatetime",
					"flightDatetime",
					"pickup",
					"dropoff",
					"flightValidationData",
					"pickupDatetimeConfirmed"
				],
				fieldArray: "transportServices",
				index: this.$options.propsData.index,
				base: "viewModel",
				mutation: "SET_UPDATE_MODEL_ARRAY",
				module: "reservation"
			}),
			timeBetwenFlightAndPickupAbs() {
				return Math.abs(this.timeBetwenFlightAndPickup);
			},
			timeBetwenFlightAndPickup() {
				const pickupDatetime = moment(this.pickupDatetime);
				const flightDatetime = moment(this.flightDatetime);
				if (flightDatetime.isValid() && pickupDatetime.isValid()) {
					return flightDatetime.diff(pickupDatetime, "minutes");
				}
				return false;
			}
		};
	},
	methods: {
		calculatePickup() {
			this.calculatePickupLoading = true;
			api(this)
				.post(`/transport-services/calculate-pickup`, {
					pickup: this.pickup,
					dropoff: this.dropoff,
					flightDatetime: this.flightDatetime,
					flightData: this.flightValidationData
				})
				.then(res => {
					this.pickupDatetime = res.data.pickupDatetime;
					this.calculatePickupLoading = false;
					this.requirePrevFlightTime = res.data.requirePrevFlightTime;
					this.routeTime = res.data.routeTime;
				})
				.catch(this.$root.handleRequestError)
				.then(() => {
					this.calculatePickupLoading = false;
				});
		}
	}
};
</script>
